// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__9atN6","subTitleBold":"BoxSubTitle_subTitleBold__pE6Nb"};